import React, { Component } from 'react'

import Templates from '../../components/Templates'
import AddAddress from '../../components/Templates/AddAddress'
import AddRoute from '../../components/Templates/AddRoute'

import './TemplatesPage.scss'
import 'react-notifications/lib/notifications.css'

export default class TemplatesPage extends Component {
  state = { 
    activeTab: 0,
  }
  
  chgActiveTab = id => {
    this.setState({activeTab: id})
  }
  
  render() {
    return (<div className="row">
      <div className="col-12">
      <div className="templates-control">
        <ul className="templates-menu">
          <li className={this.state.activeTab === 1 ? 'add-route active' : 'add-route' } onClick={() => this.chgActiveTab(2)}>
            Добавить маршрут
          </li>
          <li className={this.state.activeTab === 2 ? 'add-address active' : 'add-address' } onClick={() => this.chgActiveTab(1)}>
            Добавить адрес
          </li>
        </ul>
      </div>
      </div>
      <div className="col-12">
        {this.state.activeTab === 0 ? <Templates /> : null }
        {this.state.activeTab === 1 ? <AddAddress close={this.chgActiveTab} /> : null }
        {this.state.activeTab === 2 ? <AddRoute close={this.chgActiveTab} /> : null }
      </div>  
    </div>)
  }
}
